import { isHttpError } from "@/shared/api/errors"
import { recordAppPageVisitApiV1AnalyticsPageVisitsAppPost } from "@/shared/api/generated-backend"
import { getAccessToken } from "@/shared/lib/auth"
import { captureError } from "@/shared/lib/diagnostics"
import { isAppActive, onAppActive } from "@/shared/lib/platform"

export function trackApp(): void {
	void recordAppOpen()
	onAppActive(() => void recordAppOpen())
}

async function recordAppOpen(): Promise<void> {
	if (!isAppActive()) return
	if (!(await getAccessToken())) return
	try {
		await recordAppPageVisitApiV1AnalyticsPageVisitsAppPost()
	} catch (error) {
		if (isHttpError(error) && error.status === 401) return
		captureError(error, { scope: "analytics.appOpen" })
	}
}
